<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">Set a reminder to follow-up?</h3>
      <div>
        <radio-button v-for="btn in answers"
                :key="btn.id"
                :id="btn.id"
                :name="'Set a reminder to follow-up'"
                v-model="selectedAnswer"
                :selectedValue="selectedAnswer"
                :radioValue="btn.value">
                {{ btn.label }}</radio-button>
        <span class="error ut-text-sm ut-font-bold"
            v-show="validationError">
            Please select an option</span>
      </div>
    <button @click="confirm()" class="btn btn-green-inverted confirm-btn">Confirm</button>
  </section>
</template>

<script>
import RadioButton from '@/components/Forms/RadioButton.vue';

export default {
  name: 'ProspectStageQuesFollowUpReminder',
  components: {
    RadioButton,
  },
  props: {
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: null,
      validationError: false,
      answers: [
        {
          id: 'follow-up-reminder-yes',
          value: 'yes',
          label: 'Yes',
        },
        {
          id: 'follow-up-reminder-yes-no-remove-prospect',
          value: 'no',
          label: 'No, remove this prospect',
        },
      ],
    };
  },
  computed: {},
  created() {},
  methods: {
    confirm() {
      if (!this.selectedAnswer) {
        this.validationError = true;
        return false;
      }

      if (this.selectedAnswer === 'yes') {
        // Set follow-up
        this.$emit('update-view', 'setFollowUpReminder');
      } else if (this.selectedAnswer === 'no') {
        // remove prospect
        this.$emit('update-view', 'removeProspect');
      }

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
